<!-- <section id="comp2" class="py-5 bg-comp2">
  <div class="container">
    <div class="row g-4">
      <div class="col-md-4" *ngFor="let f of items">
        <div class="card h-100 shadow-sm border-0 rounded-4">
          <div class="card-body p-4">
            <div class="comp2-icon rounded-3 d-inline-flex align-items-center justify-content-center mb-3">
              <i class="fa-solid fa-2xl" [ngClass]="f.icon"></i>
            </div>
            <div class="mt-2">
              <span class="fw-semibold mb-2 fs-20px">{{ f.title }}</span>
              <p class="text-muted mb-0 fs-14px">{{ f.desc }}</p>
            </div>            
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->

<!-- <section class="features py-5">
  <div class="container text-center">
    <h2 class="mb-5">Todo lo que necesitas para crecer</h2>
    <div class="row g-4">
      <div class="col-md-4">
        <div class="card-feature">
          <i class="icon-cloud"></i>
          <h3>Soporte 24/7</h3>
          <p>Acompañamiento constante en tu implementación.</p>
        </div>
      </div>
      </div>
  </div>
</section> -->

<!-- <section class="py-5 bg-white">
  <div class="container">
    <div class="text-center mb-5">
      <h2 class="fw-bold">Todo lo que necesitas para crecer</h2>
      <p class="text-muted">Herramientas diseñadas para potenciar tu negocio desde el primer día.</p>
    </div>
    <div class="row g-4">
      <div class="col-md-4" *ngFor="let feature of features">
        <div class="feature-card p-4 text-center border-0 shadow-sm">
          <div class="icon-box mb-3">{{ feature.icon }}</div>
          <h4>{{ feature.title }}</h4>
          <p>{{ feature.desc }}</p>
        </div>
      </div>
    </div>
  </div>
</section> -->

<section id="servicios" class="py-3 bg-white">
  <div class="container py-5">
    <div class="row text-center mb-5">
      <div class="col-12">
        <span class="text-teal fw-bold fs-26px">Nuestros Sistemas</span>
        <h2 class="display-5 fw-bold mt-2">Soluciones que impulsan tu negocio</h2>
        <p class="text-muted fs-18px">Tres sistemas diseñados para cubrir las necesidades tecnológicas de tu empresa.</p>
      </div>
    </div>

    <div class="row g-4">
      @for (item of sistemas; track item.titulo) {
        <div class="col-12 col-md-4">
          <div class="card borderCard h-100 shadow-sm p-4">
            <div class="icon-box-teal mb-3" [innerHTML]="item.icon"></div>
            <span class="fw-bold fs-20px">{{ item.titulo }}</span>
            <p class="text-muted small pt-2">
              {{ item.descripcion }}
            </p>
            <ul class="text-muted small mt-3">
              @for (beneficio of item.beneficios; track beneficio) {
                <li>
                  <i class="bi bi-check-circle-fill text-teal me-2"></i>
                  {{ beneficio }}
                </li>
              }
            </ul>
            <button type="button" class="btn btnCard text-white mt-auto" (click)="masInfo(item.url)">
              Más información &rarr;
            </button>
          </div>
        </div>
      }
      <!-- <div class="col-12 col-md-4">
        <div class="card h-100 shadow-sm p-4">
          <div class="icon-box-teal mb-3">📄</div>
          <span class="fw-bold fs-20px">Ventas y Facturación Electrónica</span>
          <p class="text-muted small">Sistema completo para gestionar tus ventas y emitir comprobantes directamente a SUNAT.</p>
          <ul class="list-unstyled text-muted small mt-3">
            <li><i class="bi bi-check-circle-fill text-teal me-2"></i> Emisión directa a SUNAT</li>
            <li><i class="bi bi-check-circle-fill text-teal me-2"></i> Boletas y facturas</li>
            <li><i class="bi bi-check-circle-fill text-teal me-2"></i> Reportes de ventas</li>
          </ul>
          <a href="#" class="text-teal text-decoration-none mt-auto">Más información &rarr;</a>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="card h-100 shadow-sm p-4">
          <div class="icon-box-teal mb-3">📱</div>
          <span class="fw-bold fs-20px">Encuéntrame</span>
          <p class="text-muted small">Genera códigos QR inteligentes para objetos, mascotas o personas. Perfil seguro y geolocalización.</p>
          <ul class="list-unstyled text-muted small mt-3">
            <li><i class="bi bi-check-circle-fill text-teal me-2"></i> Generación de QR</li>
            <li><i class="bi bi-check-circle-fill text-teal me-2"></i> Perfil personalizable</li>
            <li><i class="bi bi-check-circle-fill text-teal me-2"></i> Notificaciones</li>
          </ul>
          <a href="#" class="text-teal text-decoration-none mt-auto">Más información &rarr;</a>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="card h-100 shadow-sm p-4">
          <div class="icon-box-teal mb-3">🛒</div>
          <span class="fw-bold fs-20px">Ventas Online</span>
          <p class="text-muted small">Página web profesional para vender tus productos. Carrito de compras y gestión de pedidos.</p>
          <ul class="list-unstyled text-muted small mt-3">
            <li><i class="bi bi-check-circle-fill text-teal me-2"></i> Catálogo de productos</li>
            <li><i class="bi bi-check-circle-fill text-teal me-2"></i> Carrito de compras</li>
            <li><i class="bi bi-check-circle-fill text-teal me-2"></i> Pasarela de pagos</li>
          </ul>
          <a href="#" class="text-teal text-decoration-none mt-auto">Más información &rarr;</a>
        </div>
      </div> -->
    </div>
  </div>
</section>